<template>
  <span class="flex h-4 min-w-5 items-center justify-center rounded-md p-1 text-xs font-medium" :class="badgeClass">
    <slot />
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { UiBadgeTheme } from '../types'

const props = withDefaults(
  defineProps<{
    theme?: UiBadgeTheme
  }>(),
  {
    theme: UiBadgeTheme.Default,
  },
)

const classMap = {
  [UiBadgeTheme.Default]: 'bg-gray-20 text-gray-60',
  [UiBadgeTheme.Dark]: 'bg-badge-dark-bg text-badge-dark-color',
  [UiBadgeTheme.Highlighted]: 'bg-blue-50 text-white',
  [UiBadgeTheme.Yellow]: 'bg-badge-yellow-bg text-badge-yellow-color',
  [UiBadgeTheme.Pink]: 'bg-badge-pink-bg text-badge-pink-color',
}

const badgeClass = computed(() => classMap[props.theme] || classMap[UiBadgeTheme.Default])
</script>
